// Konfiguracja tabeli „Listy zakupowe” na karcie klienta (Panel Handlowca)

import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

/**
 * Parametry (opcje nad tabelą) – brak
 */
export const getTraderClientCardShoppingListsTableParameters = (
): IWiseTableParameter[] => {
  return [];
};

/**
 * Kolumny tabeli: numer listy, wartość
 */
export const getTraderClientCardShoppingListsTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'text',
      label: t('ID'),
      field_symbol: 'id',
      align: 'left',
      tooltip: null,
      size: 100
    },
    {
      type: 'text',
      label: t('Nazwa'),
      field_symbol: 'name',
      align: 'left',
      tooltip: null,
      size: 140
    },
    {
      type: 'text',
      label: t('Data utworzenia'),
      field_symbol: 'create_datetime',
      align: 'center',
      tooltip: null,
      size: 140
    },
    {
      type: 'text',
      label: t('Ilość produktów'),
      field_symbol: 'products_count',
      align: 'center',
      tooltip: null,
      size: 140
    }
  ];
};

/**
 * Akcje tabeli – brak
 */
export const getTraderClientCardShoppingListsTableActions = (
): IWiseTableAction[] => {
  return [];
};

/**
 * Parametry do pobierania danych (endpoint /trader/clients/:clientId/shopping_lists)
 */
export const traderClientCardShoppingListsTableLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/clients/:clientId/shopping-lists',
  params_list: null
};
